import { getDateObj as m, formatShortDate as f } from "./formatDate.js";
const g = (o) => {
  var r;
  const t = m(o);
  if (!t.getDate()) return "";
  const c = t.toLocaleString("default", {
    year: "numeric"
  }), n = t.toLocaleString("default", {
    month: "2-digit"
  }), a = t.toLocaleString("default", {
    day: "2-digit"
  }), i = t.toLocaleString("default", {
    timeStyle: "medium",
    hour12: !1
  });
  let e = (r = t.toLocaleDateString("default", {
    day: "2-digit",
    timeZoneName: "long"
  }).substring(4).match(/\b(\w)/g)) == null ? void 0 : r.join("");
  return e === "CUT" && (e = "UTC"), `${c}-${n}-${a} ${i} (${e})`;
}, y = (o, t = "week") => {
  const c = m(o).getTime(), n = Math.round((c - Date.now()) / 1e3), a = [
    60,
    3600,
    86400,
    86400 * 7,
    86400 * 30,
    86400 * 365,
    1 / 0
  ], i = [
    "second",
    "minute",
    "hour",
    "day",
    "week",
    "month",
    "year"
  ], e = a.findIndex(
    (s) => s > Math.abs(n)
  );
  if (e > 0 && t && e >= i.indexOf(t))
    return f(o);
  const r = e ? a[e - 1] : 1;
  return new Intl.RelativeTimeFormat("default", { numeric: "auto" }).format(Math.floor(n / r), i[e]);
};
export {
  g as formatISODateTime,
  y as formatRelativeTime
};
